import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

/** Additional input: `multiple:boolean = false` for multiple users icon version. */
@Component({
  selector: 'icon-user',
  imports: [CommonModule],
  templateUrl: './user-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserIconComponent extends BaseIconComponent {
  readonly multiple = input(false);
}
